import React from 'react';
import { UserFilters as UserFiltersType } from '../types';
import CustomDropdown from '../../../../../UI/CustomDropdown';
import searchBarStyles from '../../../../../../styles/SearchBar.module.css';
import customDropdownStyles from '../../../../../../styles/CustomDropdown.module.css';
import buttonStyles from '../../../../../../styles/Buttons.module.css';
import styles from '../../../../../../styles/PointScheme.module.css';

interface UserFiltersProps {
  filters: UserFiltersType;
  onFilterChange: (key: keyof UserFiltersType, value: string) => void;
  onSearchChange: (value: string) => void;
  onRefresh: () => void;
  onAddMember: () => void;
  roleOptions: Array<{ value: string; label: string }>;
  statusOptions: Array<{ value: string; label: string }>;
  canManageUsers: boolean;
}

const UserFilters: React.FC<UserFiltersProps> = ({
  filters,
  onFilterChange,
  onSearchChange,
  onRefresh,
  onAddMember,
  roleOptions,
  statusOptions,
  canManageUsers
}) => {
  return (
    <div className={styles.headerRow}>
      <div className={styles.searchWrapper}>
        <div className={searchBarStyles.searchBar}>
          <input
            type="text"
            placeholder="Search by name, email, or ID"
            value={filters.search}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          <button type="submit">
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </button>
        </div>
      </div>

      

      <div className={styles.headerActions}>
        {canManageUsers && (
          <button 
            className={`${buttonStyles.btn} ${buttonStyles.btnPrimary}`}
            onClick={onAddMember}
            title="Add Member"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            <span className={styles.btnText}>Add</span>
          </button>
        )}
        <CustomDropdown
        options={roleOptions}
        value={filters.role}
        onChange={(value: string | string[]) => onFilterChange('role', Array.isArray(value) ? value[0] : value)}
        placeholder="All Roles"
        size="sm"
        variant="outlined"
        className="filter"
        />
        
        <CustomDropdown
        options={statusOptions}
        value={filters.status}
        onChange={(value: string | string[]) => onFilterChange('status', Array.isArray(value) ? value[0] : value)}
        placeholder="All Status"
        size="sm"
        variant="outlined"
        className="filter"
        />
        
        <button 
          className={`${buttonStyles.btn} ${buttonStyles.btnSecondary}`}
          onClick={onRefresh}
          title="Refresh"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 2v6h-6"></path>
            <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
            <path d="M3 22v-6h6"></path>
            <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
          </svg>
          <span className={styles.btnText}>Refresh</span>
        </button>
      </div>
    </div>
  );
};

export default UserFilters;

